import type { User } from "../../types";
import { apiClient } from "../core/apiClient";

interface results<T = any> {
  users: T
} 

export class UserService {
  async getUsers(params?: { page?: number; limit?: number; role?: string }): Promise<User[]> {
    const queryString = params ? new URLSearchParams(params as any).toString() : '';
    const endpoint = `/users${queryString ? `?${queryString}` : ''}`;
    
    const response = await apiClient.get<User[]>(endpoint);
    return response.data;
  }

  async getListUsers(): Promise<results> {
    const endpoint = `/users`;
    const response = await apiClient.get<results>(endpoint);
    return response.data;
  }

  async getUserById(id: string): Promise<User> {
    const response = await apiClient.get<User>(`/users/${id}`);
    return response.data;
  }

  async createUser(userData: Omit<User, 'id'>): Promise<User> {
    const response = await apiClient.post<User>('/users', userData);
    return response.data;
  }

  async updateUser(id: string, userData: Partial<User>): Promise<User> {
    const response = await apiClient.put<User>(`/users/${id}`, userData);
    return response.data;
  }

  async deleteUser(id: string): Promise<void> {
    await apiClient.delete(`/users/${id}`);
  }

  async uploadAvatar(userId: string, file: File): Promise<{ avatarUrl: string }> {
    const response = await apiClient.uploadFile<{ avatarUrl: string }>(`/users/${userId}/avatar`, file);
    return response.data;
  }
}

export const userService = new UserService();